import { apiClient } from '@/libs/api'

export type BulkApproveRequestsRequest = {
  tenantKey: string
  shippingDate: string
}

export const bulkApproveRequests = async ({
  tenantKey,
  shippingDate
}: BulkApproveRequestsRequest) => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .dispatches.bulk_approve_requests.$post({
      body: {
        shippingDate
      }
    })
  return data
}
